module.exports = __webpack_public_path__ + "img/vard2.50de4d0d.png";